let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("1vMxa")).then(() => parcelRequire('3ta5a'));